// src/api/config.ts

// API Configuration Constants
export const BASE_API_URL = import.meta.env.VITE_API_BASE_URL;
export const AUTH_API_URL = import.meta.env.VITE_API_AUTH_BASE_URL;
export const API_V2_BASE_URL = import.meta.env.VITE_API_V2_BASE_URL;
export const INTEGRATIONS_BASE_URL = import.meta.env.VITE_INTEGRATIONS_BASE_URL;
export const IMAGE_UPLOAD_URL = import.meta.env.VITE_IMAGE_UPLOAD_URL;
export const REQUEST_TIMEOUT = import.meta.env.VITE_API_TIMEOUT;
